import { Button, Checkbox, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function Eviction({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? false : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        colon={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Eviction/Lockout Complete- URGENT" />
          </Col>
          <Col span={24}>
            <h3 className="yellow-info-text">
              Send this message to the property owner- put the address on the
              subject line of the email
            </h3>
          </Col>
          <Col span={24}>
            <p>
              We have completed the eviction on your property listed above.
              Below you will find a list of the next steps coming.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -We have rekeyed the house to secure it for the coming work to get
              it ready to rent.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -We will begin the move out process for the tenant and the
              property listing and make ready process as well. Our goal is to
              get your home ready and rented as soon as possible.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -Our make ready contractor will be contacting you with photos and
              a list of needed repairs if any.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -We will bill the tenants deposit for any outstanding charges
              owed, damages or other items. If the deposit is not sufficient to
              cover the expenses we will send them to collections soon to help
              you recoup any additional lost expenses you have.
            </p>
          </Col>
          <Col span={24}>
            <p>
              If you have any questions along the way please feel free to reach
              out to me.
            </p>
          </Col>
          <Col span={24}>
            <Form.Item label="1" name="isHomeVacant" valuePropName="checked">
              <Checkbox>Verify that home is vacant</Checkbox>
            </Form.Item>
            <Form.Item
              label="2"
              name="verifyLocksChanged"
              valuePropName="checked"
            >
              <Checkbox>Verify that locks have been changed</Checkbox>
            </Form.Item>
            <Form.Item
              label="3"
              name="verifyDateGivenToXTenant"
              valuePropName="checked"
            >
              <Checkbox>
                Verify you have entered move out date for the former tenant
              </Checkbox>
            </Form.Item>
            <Form.Item label="4" name="removeEvictTag" valuePropName="checked">
              <Checkbox>
                Remove the "evict" tag from the tenants page!!
              </Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <p className="red-info-heading green-info-text">
              This letter below must be mailed certified mail to the last known
              address of the tenant which often is the property address.
            </p>
          </Col>
          <Col span={24}>
            <p className="red-info-heading green-info-text">
              This is only needed if items you deem to be of value have been
              left, if in doubt speak with the broker in charge.
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default Eviction;
